import React, { Fragment } from 'react'

export default ({data, name, onChange}) => {
    return (
        <div className='d-flex'>
            {
                data.map(({value, text, checked}, key) => {
                    return (
                        <label key={key} className="label-kc radio-inline d-flex align-items-center mr-3">
                            <input onChange={e => onChange(e.target)} className='mr-2' type="radio" value={value} name={name} checked={checked} /> {text}
                        </label>
                    )
                })
            }
        </div>
    )
}
